import { http } from '../util/http'
import { API_KOTLIN_DOMAIN } from '../config'
import headers from './employeeSystemHeader'

// 获取卡券列表
export const fetchCouponList = (params) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-table/coupon`,
    params,
  })
}

// 获取卡券详情
export const fetchCouponDetail = (params) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-table/coupon/detail`,
    params,
  })
}

// 新建/修改卡券
export const postCouponData = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-table/coupon`,
    method: 'post',
    data,
  })
}

// 删除卡券
export const disableCoupon = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-table/coupon/disable`,
    method: 'post',
    data,
  })
}

// 作废卡券
export const postDisableCoupon = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-table/coupon/cancel`,
    method: 'post',
    data,
  })
}

// 卡券持有者列表（免费领取记录与购买记录）
export const fetchCouponRecordList = (params) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-table/coupon/couponMembers`,
    params,
  })
}



// WEBPACK FOOTER //
// ./src/api/cardManage.js